// src/DataDownload.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var DataDownload_default = createIcon({
  displayName: "DataDownload",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("rect", {
        opacity: "0",
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M11.0142 2C10.4622 2 10.0142 2.448 10.0142 3V11H6.51424C6.2381 11 6.01424 11.2239 6.01424 11.5C6.01426 11.6326 6.06695 11.7598 6.16073 11.8535C6.17072 11.8637 6.18115 11.8735 6.19198 11.8828L11.2974 16.6973L11.3306 16.7285C11.5157 16.9026 11.7602 16.9996 12.0142 17C12.2683 16.9996 12.5127 16.9026 12.6978 16.7285L12.7115 16.7168C12.7148 16.7129 12.718 16.709 12.7213 16.7051L17.8248 11.8926C17.8349 11.8839 17.8447 11.8747 17.8541 11.8652L17.8619 11.8594C17.8639 11.8574 17.8658 11.8555 17.8678 11.8535C17.9615 11.7598 18.0142 11.6326 18.0142 11.5C18.0142 11.2239 17.7904 11 17.5142 11H14.0142V3C14.0142 2.448 13.5662 2 13.0142 2H12.0142H11.0142ZM3.01424 20C2.65361 19.9949 2.31816 20.1844 2.13635 20.4959C1.95455 20.8074 1.95455 21.1926 2.13635 21.5041C2.31816 21.8156 2.65361 22.0051 3.01424 22H21.0142C21.3749 22.0051 21.7103 21.8156 21.8921 21.5041C22.0739 21.1926 22.0739 20.8074 21.8921 20.4959C21.7103 20.1844 21.3749 19.9949 21.0142 20H3.01424Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      })
    ]
  })
});

export {
  DataDownload_default
};
